import { render, staticRenderFns } from "./AppCalendarSwitch.vue?vue&type=template&id=76f30f96&scoped=true&"
import script from "./AppCalendarSwitch.vue?vue&type=script&lang=js&"
export * from "./AppCalendarSwitch.vue?vue&type=script&lang=js&"
import style0 from "./AppCalendarSwitch.vue?vue&type=style&index=0&id=76f30f96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f30f96",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
